import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(
  () => import('modules/finance/pages/FinancialWorkspacePage/Settings/RootPage')
)

const FinancialWorkspaceSettings = React.lazy(
  () => import('modules/finance/components/FinancialWorkspace/components/Settings')
)

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.financialWorkspace.path,
      element: <RootPage />,
      children: [
        {
          handle: {
            meta: () => {
              return { title: i18n.t('company_settings.finance.financial_workspace.title') }
            },
          },
          element: <FinancialWorkspaceSettings />,
          index: true,
        },
      ],
    },
  ]
}

export default settingsRoutes
